import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom'
import { Card, Input, Label, Table } from 'reactstrap'
import { useLoader } from '../../_helper/LoaderContext';
import { useCurrency } from '../../_helper/currencyContext';
import { useLab } from '../../_helper/PharmacyProvider';
import MyPagination from '../pagination';
import { Plus, PlusCircle, Search, SearchIcon } from "lucide-react";
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { deleteUser, getUserList, statusUser } from './service/user-service';
import { toast } from 'react-toastify';
import { FormLabel } from 'react-bootstrap';
import SearchFilterButtons from '../SearchFilterButtons';
import { useLicense } from '../../_helper/LicenseContext';

export default function LabUserHome() {

    const { t } = useTranslation();
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const { getCurrencySymbol } = useCurrency()
    const { currentLab } = useLab();
    const { decodeTokenOnly } = useLicense();
    const [allowedUsers, setAllowedUsers] = useState(null)

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage])

    useEffect(() => {
        decodeTokenOnly().then(decoded => {
            if (decoded.limitations.users_allowed) {
                // console.log(decoded)
                setAllowedUsers(decoded.limitations.users_allowed);
            }
        });
    }, []);

    const getList = async (query = appliedSearch) => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", query);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            const res = await getUserList(form_data)
            // console.log(res)
            if (res.data.success == true) {
                setUsers(res.data.data.data)
                setTotalEntries(res.data.data.total || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const handleSearch = () => {
        const query = search.trim();
        setAppliedSearch(query);
        if (currentPage === 1) {
            getList(query);
        } else {
            setCurrentPage(1);
        }
    };

    const handleClear = () => {
        setSearch("");
        if (!appliedSearch) return;
        setAppliedSearch("");
        if (currentPage === 1) {
            getList("");
        } else {
            setCurrentPage(1);
        }
    };

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const DeleteUser = (data) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("You want to delete this user?"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, Delete It!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await deleteUser(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    }

    const handleToggleStatus = (data) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: data.status == "active"
                ? t("You want to inactivate this user?")
                : t("You want to activate this user?"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${data.status == "active" ? t("Inactive") : t("Active")}`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const dataStatus = data.status == "active" ? "inactive" : "active";
                    const form_data = new FormData();
                    form_data.append("status", dataStatus)
                    const res = await statusUser(data._id, form_data)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    }

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>

            <Card>
                <div className="px-3 mt-4">
                    <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                        <div className="input-group" style={{ flex: "1 1 260px", maxWidth: 460 }}>
                            <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                            <input
                                type="text"
                                className="form-control icon_form"
                                placeholder={t("Search By Name / Email / Mobile")}
                                aria-label={t("Search By Name / Email / Mobile")}
                                aria-describedby="basic-addon1"
                                style={{ borderLeft: 'none' }}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleSearch();
                                }}
                            />
                        </div>
                        <SearchFilterButtons onSearch={handleSearch} onClear={handleClear} />
                        <div className="ms-md-auto">
                            {(users.length < allowedUsers) && (
                                <Link to={`${process.env.PUBLIC_URL}/add-user`}>
                                    <button className="btn btn-primary">
                                        {t("Add")}
                                    </button>
                                </Link>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black custom-slim-scrollbar"
                            >
                                <Table className="mb-0 table-center table-bordered table-hover doctor-table" style={{ tableLayout: "fixed", overflowX: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th className="text-center bg-primary tw-text-center" style={{
                                                width: "50px"   // 👈 add width only to first column
                                            }}>
                                                <b>#</b>
                                            </th>
                                            <th className="bg-primary text-white text-left" style={{ width: '160px' }}><b>{t("Name")}</b></th>
                                            <th className="bg-primary text-white text-left" style={{ width: '180px' }}><b>{t("Email")}</b></th>
                                            <th className="bg-primary text-white" style={{ width: '130px' }}><b>{t("Mobile")}</b></th>
                                            {/* <th className="bg-primary text-white" style={{ width: '180px' }}><b>Address</b></th>
                                            <th className="bg-primary text-white" style={{ width: '100px' }}><b>Country</b></th>
                                            <th className="bg-primary text-white" style={{ width: '100px' }}><b>City</b></th> */}
                                            <th className="bg-primary text-white text-center" style={{ width: '80px' }}><b>{t("Status")}</b></th>
                                            <th className="bg-primary text-white text-center" style={{ width: '80px' }}><b>{t("Action")}</b></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.length > 0 ? (
                                            users.map((item, index) => {
                                                const serialNumber = getStartingSerialNumber() + index;
                                                return (
                                                    <tr key={item.id} className={index % 2 === 0 ? '' : ''}>
                                                        <td className="text-center font-weight-bold">
                                                            {serialNumber}
                                                        </td>
                                                        <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            <div
                                                                className="tw-font-medium"
                                                                style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                                data-tooltip-id={`cname-tooltip-${item._id}`}
                                                                data-tooltip-content={item.contact_person?.full_name}
                                                            >
                                                                {item.contact_person?.full_name}
                                                            </div>
                                                            <Tooltip id={`cname-tooltip-${item._id}`} place="top" />
                                                        </td>
                                                        <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            <div
                                                                className="tw-font-medium"
                                                                style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                                data-tooltip-id={`cemail-tooltip-${item._id}`}
                                                                data-tooltip-content={item.contact_person?.contact_email}
                                                            >
                                                                {item.contact_person?.contact_email}
                                                            </div>
                                                            <Tooltip id={`cemail-tooltip-${item._id}`} place="top" />
                                                        </td>
                                                        <td style={{ whiteSpace: "nowrap" }}>
                                                            +{item.contact_person?.mobile}
                                                        </td>
                                                        {/* <td>
                                                            {item.contact_person?.address || "---"}
                                                        </td>
                                                        <td>
                                                            {item.contact_person?.country || "---"}
                                                        </td>

                                                        <td>
                                                            {item.contact_person?.city | "---"}
                                                        </td> */}
                                                        <td className="text-center">
                                                            <Label className="switch doctor-switch">
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={item.status === "active"}
                                                                    onChange={() => handleToggleStatus(item)}
                                                                />
                                                                <span className="switch-state"></span>
                                                            </Label>
                                                        </td>

                                                        <td className="text-center">
                                                            <div className="d-inline-flex align-items-center justify-content-center">
                                                                <Link to={`${process.env.PUBLIC_URL}/edit-user/${item._id}`}>
                                                                    <Tooltip id={`edit-${item._id}`} place="top" content={t("Edit")} />
                                                                    <button className='success-action-button me-1' data-tooltip-id={`edit-${item._id}`}>
                                                                        <i className="fa fa-pencil-square" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </Link>
                                                                {/* <Link to={`${process.env.PUBLIC_URL}/edit-user/${item._id}`}> */}
                                                                {/* <Tooltip id="edit" place="top" content="Edit" />
                                                                    <button className='success-action-button me-1' onClick={() => DeleteUser(item)} data-tooltip-id="edit" >
                                                                        <i className="fa fa-trash" style={{ fontSize: "18px" }}></i>
                                                                    </button> */}
                                                                {/* </Link> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            )
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={6}
                                                    className="text-center py-4 text-muted"
                                                >
                                                    {t("No data available")}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                                <div className="show-entries">
                                    <FormLabel>{t("Show")}&nbsp;</FormLabel>
                                    <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                        onChange={handlePageSizeChange} className="form-control">
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={50}>50</option>
                                    </select>&nbsp;
                                    <FormLabel>{t("entries")}</FormLabel>
                                </div>
                                <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                            </div>
                            {/* <div className="mt-3 mb-3">
                                <MyPagination totalPages={totalPages}
                                    currentPage={currentPage}
                                    onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                            </div> */}
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}
